module.exports = __webpack_public_path__ + "img/MCD1000.d641e596.jpg";